export const imagesMap = {
  Frente: "frente",
  Posterior: "posterior",
  "Lateral 1": "lateral1",
  "Lateral 2": "lateral2",
  "Llanta FD": "llantaFd",
  "Llanta FI": "llantaFi",
  "Llanta PD": "llantaPd",
  "Llanta PI": "llantaPi",
  "Checklist Físico": "checkPhysical",
  Horómetro: "checkHorometro"
};
